import { ToastContainer } from 'react-toastify'
import { useLocation } from 'react-router-dom'
import { useTopUserData } from './useTopUserData'
import { TopUserDataStyles } from '../Top.style'
import { useOrganizationList } from '../../OrganizationList/useOrganizationList'
import { ehRotaAdministrativa } from '../../../utils/rotaAdministrativa'

export function TopUserData() {
  const { userData } = useTopUserData()
  const { useOrganizationsList } = useOrganizationList()
  const XTENANTID = localStorage.getItem('X-TENANT-ID')
  const useOrg = XTENANTID != null ? XTENANTID.slice(1, -1).toUpperCase() : ' '

  const location = useLocation()
  const { pathname } = location

  const tenantId =
    useOrganizationsList != null
      ? useOrganizationsList.map(organizacao =>
          organizacao.tenantId.toUpperCase()
        )
      : []

  const tenantIdArrayIndex = tenantId.findIndex(nome => nome.includes(useOrg))

  const org =
    tenantIdArrayIndex !== -1 && useOrganizationsList
      ? useOrganizationsList.map(organizacao => organizacao.nome)
      : []

  return (
    <TopUserDataStyles>
      <ToastContainer theme="dark" />
      <p>
        <strong>{userData?.nome}</strong>
      </p>
      {/* Mesma regra de prefixo do Menu e do logo: a lista fixa que estava aqui nunca recebeu
          'adm-gestao-tenants' nem 'adm-central-resultados', entao o nome da organizacao do TENANT
          continuava no topo enquanto o super-admin estava no ambiente administrativo. */}
      {ehRotaAdministrativa(pathname) ? (
        ''
      ) : (
        <p className="email">{org[tenantIdArrayIndex]}</p>
      )}
    </TopUserDataStyles>
  )
}
